<template>
  <div class="layout--full-page w-full">
    <div
      class="w-full h-screen bg-img vx-row no-gutter flex flex-col justify-center items-center"
      v-if="showAuth"
    >
      <div class="vx-col w-1/3 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-col no-gutter justify-center items-center">
              <div class="vx-col p-10 hidden lg:block">
                <img
                  src="/logo.png"
                  alt="login"
                  class="mx-auto"
                  width="200px"
                />
              </div>
              <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Login</h4>
                  </div>
                  <div class="w-full">
                    <vs-input
                      name="Device ID"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Device ID"
                      class="w-full"
                      v-on:keyup.enter="login"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                      v-model="auth.device_id"
                    />
                    <vs-button class="mt-5 w-full" @click="login"
                      >Login</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div
      v-else
      class="w-full bg-img vx-row no-gutter flex flex-col flex-start flex-no-wrap pr-8"
      id="page-login"
      style="height:100vh;overflow:hidden"
    >
      <div class="w-full">
        <div class="w-full flex pt-24">
          <img src="/logo.png" alt="login" class="mx-auto" width="300px" />
        </div>
        <div class="w-full flex flex-col items-center justify-center pt-24">
          <h1 class="font-bold mb-5" style="font-size:50px">SELAMAT DATANG</h1>
          <h1 class="font-bold" style="font-size:40px">
            SILAHKAN MENUJU LOKET INFORMASI
          </h1>
        </div>
      </div>
      <div
        class="w-full bg-white fixed flex items-center shadow"
        style="bottom : 0"
      >
        <div class="py-3 px-5 font-bold bg-primary text-white text-xl">
          {{ time }}
        </div>
        <div style="ma" class="text-xl">
          <marquee>
            Selamat Datang dan Terima kasih atas kehadiran anda di Mal Pelayanan
            Publik Kabupaten Badung | Berita terkini :
            <span v-for="(list, index) in news" :key="index">
              {{ list.description }}
            </span>
          </marquee>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Echo from "laravel-echo";
import io from "socket.io-client";
import Axios from "axios";
import Queue from "queue";
import SectionDisplayQueue from "@/components/display/SectionDisplayQueue.vue";
import Vue from "vue";
import moment from "moment";

export default {
  data() {
    return {
      showAuth: true,
      auth: {
        device_id: ""
      },
      echo: null,
      axios: null,
      speech: null,
      voices: [],
      queue: Queue(),
      interval: null,
      onQueue: false,
      bus: new Vue(),
      time: moment().format("HH:mm"),
      news: []
    };
  },
  mounted() {
    this.init();
    this.initSpeech();
    this.queue.autostart = true;
    setInterval(this.displayTime, 1000);
    this.getNews();
    if (navigator.userAgent.indexOf("Firefox") == -1) {
      // alert("Gunakan Mozilla Firefox untuk Display");
    }
  },
  methods: {
    init() {
      if (!this.displayDevice.token) {
        this.showAuth = true;
      } else {
        this.showAuth = false;
        this.initEcho(this.displayDevice.token);
      }
    },
    login() {
      this.$vs.loading();
      this.$http
        .post(`/device/auth`, this.auth)
        .then(r => {
          if (["display", "display_only"].includes(r.data.data.type)) {
            this.$store
              .dispatch("setDisplayDevice", {
                name: r.data.data.device,
                type: r.data.data.type,
                token: r.data.data.token,
                id: r.data.data.id
              })
              .then(() => {
                this.initEcho(this.displayDevice.token);
                this.showAuth = false;
              });
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Device ini tidak sesuai.",
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
              time: 6000
            });
          }
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    initEcho(token) {
      const URL = process.env.VUE_APP_ECHO_SERVER || "coder.iseng.in:6001";
      this.echo = new Echo({
        broadcaster: "socket.io",
        host: URL,
        client: io,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      });
      this.axios = Axios.create({
        baseURL: process.env.VUE_APP_API_ENDPOINT,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      this.echo
        .private(`Device.Display.${this.displayDevice.id}`)
        .listen(".OnCallQueueEvent", e => {
          if (this.displayDevice.type == "display") {
            if (e.state == "speech") {
              this.textToSpeech(e.data.text);
            }
          }
          this.bus.$emit("reload");
        });
    },
    initSpeech() {
      this.speech = window.speechSynthesis;
      var self = this;
      if (window.speechSynthesis.getVoices().length == 0) {
        window.speechSynthesis.addEventListener("voiceschanged", function() {
          self.voices = window.speechSynthesis.getVoices();
        });
      }
    },
    textToSpeech(text) {
      let utter = new SpeechSynthesisUtterance();
      utter.rate = 0.8;
      utter.pitch = 1;
      utter.text = text;
      utter.voice = this.voices[56];
      utter.volume = 1;
      utter.lang = "id-ID";
      utter.onerror = function() {
        alert("Access Denied for Text To Speech");
      };
      this.queue.push(function() {
        return new Promise(resolve => {
          window.speechSynthesis.speak(utter);
          utter.addEventListener("end", function() {
            resolve();
          });
        });
      });
    },
    displayTime() {
      this.time = moment().format("HH:mm");
    },
    getNews() {
      this.axios.get(`/device/display/news`).then(r => {
        this.news = r.data.data.news.news;
      });
    }
  },
  computed: {
    ...mapGetters(["displayDevice"])
  },
  components: {
    SectionDisplayQueue
  }
};
</script>
